// ============================================================
// PAYMENT PLANS PAGINATION COMPONENT
// ============================================================

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

interface PaymentPlansPaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  filteredCount: number;
}

export function PaymentPlansPagination({
  totalPages,
  currentPage,
  onPageChange,
  filteredCount,
}: PaymentPlansPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="bg-slate-50 border-t border-slate-200 px-5 py-3 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-b-xl">
      <span className="text-sm text-slate-500 font-medium">
        Page {currentPage} sur {totalPages} · {filteredCount} résultats
      </span>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="p-1.5 rounded border border-slate-200 text-slate-500 hover:bg-white disabled:opacity-40 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={cn(
              'w-8 h-8 flex items-center justify-center rounded border text-sm font-medium transition-colors',
              p === currentPage
                ? 'bg-primary text-white border-primary shadow-sm'
                : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50',
            )}
          >
            {p}
          </button>
        ))}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="p-1.5 rounded border border-slate-200 text-slate-500 hover:bg-white disabled:opacity-40 transition-colors"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
